

export const DETECT_LOCATION_API = "https://api.bigdatacloud.net/data/reverse-geocode-client";
export const PRODUCTION = "production";
export const BMS_API_KEY = process.env.NEXT_PUBLIC_BMS_API_KEY || "carjunction";

export const MODAL_TYPE = {
  LOGIN_SIGNUP: 'LOGIN_SIGNUP',
} as const;

export type ModalType = keyof typeof MODAL_TYPE;

/** Session ids for `modalSession` — one active modal at a time per tab. */
export const THANKS_POPUP_SESSION_ID = "lead-thanks-popup";
export const SPLASH_POPUP_SESSION_ID = "lead-splash-popup";
export const LEAD_FORM_MODAL_SESSION_ID = "lead-form-modal";
export const BRAND_REQUEST_MODAL_SESSION_ID = "brand-request-modal";
export const APP_URL = process.env.NEXT_PUBLIC_APP_URL || "http://localhost:3000";
export const SITE_NAME = "Car Junction";
export const CAR_LOGO_URL = `${process.env.NEXT_PUBLIC_CDN_STATIC_URL}car-junction-logo.svg`;
export const CDN_URL = process.env.NEXT_PUBLIC_CDN_URL;
export const CDN_VIDEO_URL = process.env.NEXT_PUBLIC_CDN_VIDEO_URL || '';
export const SIDEBAR_DEALER_LIMIT = 3;

// Sponsored vehicle should be provided by the API at runtime; do not hardcode here.

export const BUDGET_PAGE_PRICE_RANGES = {
  "cars-under-5-lakh": {
    label: "Under 5 Lakh",
    min: 0,
    max: 500000,
  },
  "cars-under-6-lakh": {
    label: "Under 6 Lakh",
    min: 500000,
    max: 600000,
  },
  "cars-under-7-lakh": {
    label: "Under 7 Lakh",
    min: 600000,
    max: 700000,
  },
  "cars-under-8-lakh": {
    label: "Under 8 Lakh",
    min: 700000,
    max: 800000,
  },
  "cars-under-9-lakh": {
    label: "Under 9 Lakh",
    min: 800000,
    max: 900000,
  },
  "cars-under-10-lakh": {
    label: "Under 10 Lakh",
    min: 900000,
    max: 1000000,
  },
  "cars-under-15-lakh": {
    label: "Under 15 Lakh",
    min: 1000000,
    max: 1500000,
  },
  "cars-under-20-lakh": {
    label: "Under 20 Lakh",
    min: 1500000,
    max: 2000000,
  },
  "cars-under-25-lakh": {
    label: "Under 25 Lakh",
    min: 2000000,
    max: 2500000,
  },
  "cars-under-30-lakh": {
    label: "Under 30 Lakh",
    min: 2500000,
    max: 3000000,
  },
  "cars-under-35-lakh": {
    label: "Under 35 Lakh",
    min: 3000000,
    max: 3500000,
  },
  "cars-under-50-lakh": {
    label: "Under 50 Lakh",
    min: 3500000,
    max: 5000000,
  },
  "cars-above-50-lakh": {
    label: "Above 50 Lakh",
    min: 5000000,
    max: undefined,
  },
};

export const bannerDimensions = {
  desktop: { width: 1920, height: 445 },
  mobile: { width: 618, height: 325 },
  tablet: { width: 991, height: 550 }
};

export const SEATING_CAPACITY = {
  "2-seater-cars": { label: '2 Seater', value: 2 },
  "4-seater-cars": { label: '4 Seater', value: 4 },
  "5-seater-cars": { label: '5 Seater', value: 5 },
  "6-seater-cars": { label: '6 Seater', value: 6 },
  "7-seater-cars": { label: '7 Seater', value: 7 },
  "8-seater-cars": { label: '8 Seater', value: 8 },
  "9-seater-cars": { label: '9 Seater', value: 9 },
}
export const PRIORITY_BRANDS = ["mahindra", "hyundai", "maruti", "toyota", "tata", "kia", "honda", "skoda", "volkswagen", "mg", "renault", "nissan"];
export const BRAND_PRIORITIES = ['p-0', 'p-1', 'p-2', 'p-3'] as const;
export type BrandPriority = (typeof BRAND_PRIORITIES)[number];
export const DEFAULT_BRAND_PRIORITY: BrandPriority = 'p-3';
export const FUEL_TYPES = ['Petrol', 'Diesel', 'CNG', 'Electric', 'Hybrid'];
export const TRANSMISSIONS = [
  { name: 'Manual', slug: 'manual' },
  { name: 'Automatic', slug: 'automatic' },
  { name: 'AMT', slug: 'amt' },
  { name: 'DCT', slug: 'dct' },
  { name: 'CVT', slug: 'cvt' }
] as const;
export const yearString = String(new Date().getFullYear());
export const monthString = new Date().toLocaleString('en-IN', { month: 'long' });
export const BODY_TYPES = [
  { name: 'SUV', slug: 'suv' },
  { name: 'Sedan', slug: 'sedan' },
  { name: 'Hatchback', slug: 'hatchback' },
  { name: 'MUV', slug: 'muv' },
  { name: 'Convertible', slug: 'convertible' },
  { name: 'Coupe', slug: 'coupe' },
  { name: 'Minivan', slug: 'minivan' },
  { name: 'Luxury', slug: 'luxury' },
  { name: 'MPV', slug: 'mpv' },
  { name: 'Pickup Truck', slug: 'pickup-truck' }
];

export const DEFAULT_SORT_OPTION = "sort_order_asc";

export const FILTER_SORT_OPTIONS: { label: string; labelTo?: string; value: string; outLabel: string }[] = [
  { label: "Popularity", value: "sort_order_asc", outLabel: "Sort" },
  { label: "Newest", value: "launch_date_desc", outLabel: "Sort" },
  { label: "Price: Low", labelTo: "High", value: "price_asc", outLabel: "Low to High" },
  { label: "Price: High", labelTo: "Low", value: "price_desc", outLabel: "High to Low" },
];

export const brandPriorityOrder = ["mahindra", "hyundai", "maruti", "toyota", "tata", "kia", "honda", "skoda", "volkswagen", "mg", "renault", "nissan"];

export const BRAND_BUDGET_PAGE_PRICE_RANGES = {
  "cars-under-5-lakh": {
    label: "Under 5 Lakh",
    min: 0,
    max: 500000,
  },
  "cars-under-6-lakh": {
    label: "Under 6 Lakh",
    min: 500000,
    max: 600000,
  },
  "cars-under-7-lakh": {
    label: "Under 7 Lakh",
    min: 600000,
    max: 700000,
  },
  "cars-under-8-lakh": {
    label: "Under 8 Lakh",
    min: 700000,
    max: 800000,
  },
  "cars-under-9-lakh": {
    label: "Under 9 Lakh",
    min: 800000,
    max: 900000,
  },
  "cars-under-10-lakh": {
    label: "Under 10 Lakh",
    min: 900000,
    max: 1000000,
  },
  "cars-under-15-lakh": {
    label: "Under 15 Lakh",
    min: 1000000,
    max: 1500000,
  },
  "cars-under-20-lakh": {
    label: "Under 20 Lakh",
    min: 1500000,
    max: 2000000,
  },
  "cars-under-25-lakh": {
    label: "Under 25 Lakh",
    min: 2000000,
    max: 2500000,
  },
  "cars-under-30-lakh": {
    label: "Under 30 Lakh",
    min: 2500000,
    max: 3000000,
  },
};
